module.exports = __webpack_public_path__ + "static/media/team.d8104a94.png";